import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getVehicles = async ({ commit }) => {
  commit('setVehicleIsLoading', true);
  let url = `/vehicles/selectable`;

  await connection.get(url)
    .then(res => {
      const vehicles = res.data.data;
      commit('setVehiclesSelectable', vehicles);
      commit('setVehicleIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setVehicleIsLoading', false);
    });
}

export const loadVehicles = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setVehicleIsLoading', true);
    let url = `/vehicles`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        console.log(res);
        const vehicles = res.data.data;
        commit('setVehicles', vehicles);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setVehiclesPaginated', res.data);
        commit('setVehicleIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setVehicleIsLoading', false);
      });
}

export const vehicleById = async ({ commit }, id) => {
  commit('setVehicleIsLoading', true);
  await connection.get(`/vehicles/${id}`)
    .then(res => {
      commit('setVehicleDetail', res.data.data);
      commit('setVehicleIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setVehicleIsLoading', false);
    });
}

export const storeVehicle = async ({ commit }, vehicle) => {
  commit('setVehicleIsCreating', true);
  await connection.post(`/vehicles/create`, vehicle)
    .then(res => {
      commit('saveNewVehicles', res.data.data);
      commit('setVehicleIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setVehicleIsCreating', false);
    });
}

export const updateVehicle = async ({ commit }, vehicle ) => {
  commit('setVehicleIsUpdating', true);
  await connection.put(`/vehicles/${vehicle.id}/update`, vehicle)
    .then(res => {
      commit('saveUpdatedVehicle', res.data.data);
      commit('setVehicleIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setVehicleIsUpdating', false);
    });
}

export const deleteVehicle = async ({ commit }, vehicle) => {
  commit('setVehicleIsDeleting', true);
  await connection.delete(`/vehicles/${vehicle.id}/delete`)
    .then(res => {
  console.log(res.data.data);

      commit('setDeleteVehicle', res.data.data);
      commit('setVehicleIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setVehicleIsDeleting', false);
    });
}
